import * as React from "react"
import { graphql, Link, navigate } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { TPost, TCategory } from "../../types"
import * as newsListing from "../../components/blocks/NewsListing.css"
import * as standardCardStyle from "./StandardCard.css"
import {
  Text,
  Button,
} from "../ui"

export type NewsListingProps = {
  title: string
  desktopRight: Boolean
  postsToShow: string
  newsItems: TPost[]
  newsCategories: TCategory[]
}

export default function NewsListing(props: NewsListingProps)  {
  
  const truncateSummary = (text, length = 10000) => {
    return (text.length > length) ? text.substr(0, length-1) + '...' : text;
  };
  const { newsItems } = props
  //newsItems.sort((a: any, b: any) => new Date(b.meta.updatedAt).getTime() - new Date(a.meta.updatedAt).getTime());

  return (
    <section className={newsListing.listingCard}>
      <div className={standardCardStyle.content}>
        <Link to={`/news/`} className={newsListing.newsArticleLink}>
          <Text as="h2" variant="superHeading"><span style={{ lineHeight: 1, display: "block" }}>{props.title}</span></Text>
        </Link>
      </div>
      <div className={newsListing.newsArticles}>
        {newsItems
          .slice(0, 3)
          .map((newsItem, index) => {
              return ( 
                  <div key={newsItem.id} className={newsListing.newsArticle}>
                    { newsItem.title && (
                      <Link to={`/news/${newsItem.slug}/`} className={newsListing.newsArticleLink}> 
                        <h4 className={newsListing.newsArticleTitle}>{newsItem.title}</h4>
                      </Link>
                      )}
                    { newsItem.summary && (
                      <Link to={`/news/${newsItem.slug}/`} className={newsListing.newsArticleLink}>
                        <p className={newsListing.newsArticleSummary}>{truncateSummary(newsItem.summary)} <strong>[Read More]</strong></p>
                      </Link>
                    )}
                  </div>
              )
          })}
      </div>
  </section>
  )
}

export const query = graphql`
  fragment NewsListingContent on NewsListing {
    id
    title
    desktopRight
    newsItems {
      id
      title
      summary
      slug
      avatar {
        title
        ... on DatoCmsAsset {
          gatsbyImageData(
            imgixParams: {w: "1200"}
          )
        }
      }
      ... on DatoCmsNewsPost {
        id
        meta {
          updatedAt
        }
      }
      categories {
        slug
      }
    }
    newsCategories {
      slug
    }
  }
`